import { render, staticRenderFns } from "./SampleCart.vue?vue&type=template&id=4d66b89a"
import script from "./SampleCart.vue?vue&type=script&lang=ts"
export * from "./SampleCart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports